import { RootState } from "../index";

export const getSlice = (state: RootState) => state.app;
export const getUserProfile = (state: RootState) => getSlice(state).userProfile;
export const getActiveModal = (state: RootState) => getSlice(state).activeModal;
